import { Field, Select } from "@fluentui/react-components";
import React, { useState } from "react";

export interface CafeSelectorViewProps {
  regionOptions: { key: string; text: string }[];
  cafeOptions: { key: string; text: string }[];
  onRegionSelect: (option?: { key: string; text: string }) => void;
  onCafeSelect: (option?: { key: string; text: string }) => void;
  selectedRegionId?: string;
  selectedCafeId?: string;
}

const CafeSelectorView = ({
  regionOptions,
  cafeOptions,
  onRegionSelect,
  onCafeSelect,
  selectedRegionId,
  selectedCafeId,
}: CafeSelectorViewProps) => {
  const [selectedRegion, setSelectedRegion] = useState(regionOptions.find((r) => r.key === selectedRegionId));

  const [selectedCafe, setSelectedCafe] = useState(cafeOptions.find((c) => c.key === selectedCafeId));

  const handleRegionChange = (regionKey: string) => {
    const option = regionOptions.find((o) => o.key === regionKey);
    setSelectedRegion(option);
    onRegionSelect(option);

    setSelectedCafe(undefined);
    onCafeSelect(undefined);
  };

  const handleCafeSelect = (option?: { key: string; text: string }) => {
    setSelectedCafe(option);
    onCafeSelect(option);
  };

  return (
    <div className="container">
      <div className="inner">
        {/* Region */}
        <Field label="Choose a Region">
          <Select
            value={selectedRegion?.key ?? ""}
            onChange={(e) => handleRegionChange(e.target.value)}
            data-testid="regionDropdown"
          >
            <option value="" disabled>
              {"Choose a region... "}
            </option>
            {regionOptions.map((opt) => (
              <option key={opt.key} value={opt.key}>
                {opt.text}
              </option>
            ))}
          </Select>
        </Field>

        {/* Cafe */}
        <Field
          label="Choose a Cafe"
          style={{
            opacity: !cafeOptions.length ? 0.5 : 1,
            pointerEvents: !cafeOptions.length ? "none" : "auto",
          }}
        >
          <Select
            value={selectedCafe?.key ?? ""}
            onChange={(e) => {
              const option = cafeOptions.find((c) => c.key === e.target.value);
              handleCafeSelect(option);
            }}
            disabled={!cafeOptions.length}
            data-testid="cafeDropdown"
          >
            <option value="" disabled>
              Choose a cafe...
            </option>
            {cafeOptions.map((opt) => (
              <option key={opt.key} value={opt.key}>
                {opt.text}
              </option>
            ))}
          </Select>
        </Field>
      </div>
    </div>
  );
};

export default CafeSelectorView;
